module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-email"
  }, [(_vm.email) ? _c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.email.body))]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-dark"
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "delete",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.deleteEmail()
      }
    }
  }, [_vm._v("Delete")])], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71d62994","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email/EmailDetails.vue
// module id = 287
// module chunks = 1